import React, { useState, forwardRef, useEffect } from "react";

import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import classesAPI from "../../../../services/classes";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import teachersAPI from "../../../../services/teachers";

const UpdateClasseModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [levelName, setLevelName] = useState("");
  const [maxCapacity, setMaxCapacity] = useState("");
  const [referentId, setReferentId] = useState("");

  //
  useEffect(() => {
    setName(props?.classe?.name);
    setPresentation(props?.classe?.presentation);
    setLevelName(props?.classe?.level?.name);
    setMaxCapacity(props?.classe?.max_capacity);
    setReferentId(props?.classe?.referent_id || "");
  }, [props]);
  //
  const teachersList = teachersAPI.useGetList(
    props.schoolId,
    props.trainingId,
    props.accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => {
    const nameA = a.member?.lastname || a.member?.name || "";
    const nameB = b.member?.lastname || b.member?.name || "";
    return nameA.localeCompare(nameB);
  });
  const listTeachers = uniqueTeachers.map((teacher) => ({
    label: teacher.member?.name
      ? teacher.member.name
      : (teacher.member?.lastname?.toUpperCase() || "") + " " + (teacher.member?.firstname || ""),
    value: teacher.member?.id,
  }));
  listTeachers.unshift({
    label: "-",
    value: "",
  });

  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer la classe"
        serviceAPI={classesAPI}
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        accessToken={props.accessToken}
        id={props?.classe?.id}
        data={{
          name: name,
          presentation: presentation,
          max_capacity: maxCapacity,
          referent_id: referentId,
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la classe
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Niveau de la classe
        </label>
        <InputText
          id="name"
          type="text"
          value={levelName}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          disabled={true}
        />
        <label htmlFor="referent" className="block text-900 font-medium mb-2">
          Référent(e)
        </label>
        <Dropdown
          id="referent"
          value={referentId}
          onChange={(e) => setReferentId(e.value)}
          options={listTeachers}
          optionLabel="label"
          optionValue="value"
          className="w-full mb-3"
        />

        <label htmlFor="maxCapacity" className="block text-900 font-medium mb-2">
          Capacité maximale
        </label>
        <InputNumber
          id="maxCapacity"
          value={maxCapacity}
          onValueChange={(e) => setMaxCapacity(e.value)}
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateClasseModal;
